import React, { useEffect, useState } from 'react'
import spareList from "../../../assets/spare/spareRowGema.json"
import InputSelectDropdown from '../../../elements/dropdowns/InputSelectDropdown'
import Dropdown from "../../../elements/dropdowns/Dropdown"
import CONSTANTS from '../../../CONSTANTS'
import detect from "../../../methods/detect"
import { Button } from '@mui/material'


const SpareWithQty = (props) => {
    const [list, setList] = useState([])
    // const [selectedSpare, setSelectedSpare] = useState({unit:"no", quantity:1})
    const [selected, setSelected] = useState({ unit: "no", quantity: 1 })



    const { spareObj, quantityObj, unitObj } = {
        spareObj: {
            id: "spare",
            options: list,
            label: "Select Spare",
        },
        quantityObj: {
            id: "quantity",
            label: "Quantity"
        },
        unitObj: {
            id: "unit",
            label: "Unit"
        }
    }



    useEffect(() => {
        getModifiedOptions()
    }, [])

    const getModifiedOptions = async () => {
        let modList = await spareList.map(item => ({ ...item, label: `(${item.PART_NUMBER}) ${item.DESCRIPTION}`, key: item.PART_NUMBER }))
        setList(modList)
    }

    const handleSelect = (e, key, val) => {
        if (!val) {
            return
        }

        setSelected(prev => ({ ...prev, [key]: val }))
        // setSelectedSpare(prev => ({ ...prev, [key]: [...(selectedSpare[key] || []), val] }))
    }


    const renderDropdown = () => {
        let dropProps = {
            id: spareObj.id,
            options: spareObj.options,
            selectedValues: selected[spareObj.id],
            inputprops: {
                id: "",
                value: selected.spare,
                label: spareObj.label
            },
            cbSelect: handleSelect
            // cbInput:
        }
        return <InputSelectDropdown {...dropProps} />
    }
    const renderQuantityDropDown = (data = {}) => {
        let dropProps = {
            id: quantityObj.id,
            options: [...Array(300).keys()].map(item => ({ key: item + 1, value: item + 1 })),
            selectedValues: selected[quantityObj.id],
            inputprops: {
                id: `${quantityObj.id}_input`,
                value: "",
                label: quantityObj.label
            },
            cbSelect: handleSelect,
            // cbInput:
        }
        return (
            <div className=''>
                <Dropdown {...dropProps} />
            </div>
        )
    }
    const renderUnitDropDown = (data = {}) => {
        let dropProps = {
            id: unitObj.id,
            options: CONSTANTS.SPARE_UNIT,
            selectedValues: selected[unitObj.id],
            inputprops: {
                id: `${unitObj.id}_input`,
                value: "",
                label: unitObj.label
            },
            cbSelect: handleSelect,
            // cbInput:
        }
        return (
            <div className=''>
                <Dropdown {...dropProps} />
            </div>
        )
    }

    const addSpare=()=>{
        console.log("working")
        let obj = {
            ...selected.spare,
            unit:selected.unit,
            quantity:selected.quantity,
        }
        if(selected.spare && selected.unit && selected.quantity){
            props.cb(props.slug,obj)
        }
    }

    const renderButton =()=>{
        return <Button variant="contained" onClick={addSpare}>Add Spare</Button>
    }

    if (detect.isMobile()) {
        return (
            <div>
                <div className='sparewithqty'>
                    {renderDropdown()}
                    <div className='qty-unit'>
                        {renderQuantityDropDown()}
                        {renderUnitDropDown()}
                    </div>
                </div>
                {renderButton()}
            </div>
        )
    }

    return (
        <div>
            <div className='sparewithqty'>
                {renderDropdown()}
                {renderQuantityDropDown()}
                {renderUnitDropDown()}
                {renderButton()}
            </div>
        </div>
    )
}

export default SpareWithQty